import { addRecentSystem } from './helper/recentSystems';

/**
 * Global tracker for system card clicks across the entire website
 * Uses event delegation to track clicks on any system card, regardless of location
 */
class RecentSystemsTracker {
    constructor() {
        this.initialized = false;
        this.maxCount = 3; // Default, will be updated from config if available
    }

    /**
     * Initialize the global tracker
     * Sets up event delegation and waits for Cookiebot consent
     */
    initialize() {
        if (this.initialized) {
            return;
        }

        this.initialized = true;

        // Try to get maxCount from SystemList component if it exists
        const systemListElement = document.querySelector('[data-component="SystemList"]');
        if (systemListElement && systemListElement.dataset.maxCount) {
            this.maxCount = parseInt(systemListElement.dataset.maxCount, 10);
        }

        // Wait for Cookiebot to be ready before enabling tracking
        if (window.Cookiebot && window.Cookiebot.consent) {
            this.attachGlobalClickListener();
        } else {
            window.addEventListener('CookiebotOnConsentReady', () => {
                this.attachGlobalClickListener();
            });
        }
    }

    /**
     * Attach global click listener using event delegation
     */
    attachGlobalClickListener() {
        document.body.addEventListener('click', (e) => {
            this.handleClick(e);
        });
    }

    /**
     * Handle click events on system cards
     * @param {Event} e - Click event
     */
    handleClick(e) {
        // Use closest() to find the system card, even if user clicks on child elements
        const systemCard = e.target.closest('.plain-teaser[data-node-id][data-node-type]');
        
        if (!systemCard) {
            return;
        }

        // Only track SystemPage nodes, ignore NewsPage, GuidancePage, etc.
        const nodeType = systemCard.dataset.nodeType;
        if (nodeType !== 'FIT.Intranet:Document.SystemPage') {
            return;
        }

        // Check for Cookiebot consent
        if (!window.Cookiebot || !window.Cookiebot.consent || !window.Cookiebot.consent.preferences) {
            return;
        }

        const nodeId = systemCard.dataset.nodeId;
        if (!nodeId) {
            return;
        }

        // Track the system click
        const success = addRecentSystem(nodeId, this.maxCount);

        if (success) {
            // Dispatch custom event to notify SystemList component (if it exists)
            window.dispatchEvent(new CustomEvent('recentSystemsUpdated', {
                detail: { nodeId }
            }));
        }
    }
}

// Create singleton instance
const trackerInstance = new RecentSystemsTracker();

// Export initialize function
export const initialize = () => trackerInstance.initialize();

export default { initialize };
